import { useFormik } from 'formik';
import * as Yup from 'yup';
import {  Modal,  Box,  Typography,  TextField,  Button,  useTheme,  Grid,  Autocomplete,  useMediaQuery} from '@mui/material';
import { tokens } from "../theme";
import { departamentos } from "../data/static";

// Schema de validación con Yup
const validationSchema = Yup.object({
  nombreColegio: Yup.string()
    .required('El nombre del colegio es requerido')
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .max(100, 'El nombre no puede exceder los 100 caracteres'),
    departamentoColegio: Yup.string()
    .required('La dirección del colegio es requerida')
    .min(5, 'La dirección debe tener al menos 5 caracteres')
    .max(200, 'La dirección no puede exceder los 200 caracteres')
});

const ModalNuevoColegio = ({ open, onClose, onAgregar }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const formik = useFormik({
    initialValues: {
      nombreColegio: '',
      direccionColegio: ''
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      const colegioConId = {
        ...values,
        id: Date.now()
      };
      onAgregar(colegioConId);
      resetForm();
      onClose();
    }
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-nuevo-colegio"
      aria-describedby="modal-agregar-nuevo-colegio"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: {
            xs: '90%',
            sm: '70%',
            md: 500
          },
          maxHeight: {
            xs: '90vh',
            sm: '80vh'
          },
          overflow: 'auto',
          bgcolor: colors.primary[400],
          border: `2px solid ${colors.primary[500]}`,
          boxShadow: 24,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
        }}
      >
        <Typography 
          variant={isMobile ? "h6" : "h5"} 
          component="h2" 
          gutterBottom
          sx={{ mb: 3 }}
        >
          Agregar Nuevo Colegio
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                color="quinary"
                variant="filled"
                id="nombreColegio"
                name="nombreColegio"
                label="Nombre del Colegio"
                value={formik.values.nombreColegio}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.nombreColegio && Boolean(formik.errors.nombreColegio)}
                helperText={formik.touched.nombreColegio && formik.errors.nombreColegio}
              />
            </Grid>

            <Grid item xs={12}>
                {departamentos && (
                  <Autocomplete
                    fullWidth
                    id="departamentoColegio"
                    options={departamentos}
                    getOptionLabel={(option) => option.nombre || ""}
                    value={
                      departamentos.find(
                        (departamento) =>
                          departamento.id === formik.values.departamentoColegio
                      ) || null
                    }
                    onChange={(event, value) =>
                      formik.setFieldValue(
                        "departamentoColegio",
                        value ? value.id : ""
                      )
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === (value?.id || value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="quinary"
                        variant="filled"
                        label="Departamento de Colegio"
                        error={
                          formik.touched.departamentoColegio &&
                          Boolean(formik.errors.departamentoColegio)
                        }
                        helperText={
                          formik.touched.departamentoColegio &&
                          formik.errors.departamentoColegio
                        }
                        margin="normal"
                      />
                    )}
                  />
                )}
              </Grid>

            <Grid item xs={12}>
              <Box 
                sx={{ 
                  mt: 2, 
                  display: 'flex', 
                  gap: 2, 
                  justifyContent: 'flex-end',
                  flexDirection: { xs: 'column', sm: 'row' }
                }}
              >
                <Button
                  fullWidth={isMobile}
                  variant="outlined"
                  color="quinary"
                  onClick={() => {
                    formik.resetForm();
                    onClose();
                  }}
                  sx={{ mb: { xs: 1, sm: 0 } }}
                >
                  Cancelar
                </Button>
                <Button
                  fullWidth={isMobile}
                  variant="contained"
                  color="quinary"
                  type="submit"
                  disabled={!formik.isValid || formik.isSubmitting}
                  sx={{ color: 'white' }}
                >
                  Agregar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default ModalNuevoColegio;
